
import { isLocal } from "./helpers";
import localConfig from "../components/screener/data/local-config.json";
export class s3bucket {
    async getTaxTerms() {
        try {
            const response = await fetch(`https://cie-mi-taxonomy-terms-component-searchpage-${process.env.VUE_APP_S3BUCKET}.s3.amazonaws.com/taxonomy_terms.json`);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('There was a problem accessing the s3 bucket. Fall back to preprod version:', error);
            const response = await fetch(`https://cie-mi-taxonomy-terms-component-searchpage-preprod.s3.amazonaws.com/taxonomy_terms.json`);
            const data = await response.json();

            return data;
        }
    }

    async getScreenerRegionConfig(region) {
        const s3Url = process.env[`VUE_APP_${region.toUpperCase()}_S3_CONFIG_BUCKET_URL`];

        if(isLocal()){
            return localConfig;
        }
        try {
            console.log(region);
            const response = await fetch(s3Url);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('There was a problem accessing the s3 bucket!', error);
            return null;
        }
    }
  }
  